import "./Content.scss";
import { Link } from "wouter";
import { LegalLinks } from "../LegalLinks";

export function Content() {
	return (
		<div className="home-content">
			<div className="home-content__inner">
				<div className="home-content__copy">
					<div className="home-content__group1">
						<h1 className="home-content__title">
							The Virtual Economy Technology Radar
						</h1>
						<p className="home-content__powered-by">
							<a href="https://atelier.net/" target="_blank" rel="noreferrer">
								Powered by <br />
								<strong>L'Atelier BNP Paribas</strong>
							</a>
						</p>
					</div>
					<div className="home-content__group2">
						<div className="home-content__cta">
							<button>
								<Link href="/tech-radar">
									<span>→</span> Explore the Radar
								</Link>
							</button>
						</div>

						<div>
							<p>
								The past, present and future of the Virtual Economy are rooted
								in technologies that enable, facilitate and amplify social
								experiences in a virtual setting. For the first time in the
								history of computing, we have the ability to blur the line
								between the physical world and the virtual world as computers
								learn to localise themselves, map an environment, understand the
								shape and depth of real-world objects, simulate physical
								interactions, and adapt to human behaviour.
							</p>

							<p>
								We have developed the Virtual Economy Technology Radar, an
								interactive map of 54 key emerging technologies underpinning the
								Virtual Economy - their current capabilities, likely trajectory,
								and research ecosystem. The Radar is powered by a proprietary
								data intelligence engine that tracks the most significant
								early-stage technologies globally - from idea to market.
							</p>

							<p>
								From augmented eyewear, through connected infrastructure, to
								digital identity, the Virtual Economy is on the cusp of a
								massive, rapid and pervasive expansion into our day-to-day
								existence.
							</p>
						</div>
					</div>
				</div>
				<div className="home-content__legal-links">
					<div className="home-content__legal-links__inner">
						<LegalLinks />
					</div>
				</div>
			</div>
		</div>
	);
}
